<template>
  <RouterView />
</template>

<script setup lang="ts">
console.log('部署测试2023年10月20日14:43:29');

</script>
<style lang="scss">
#app {
  min-width: 1310px;
}
</style>
